import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Packets } from "../../../utils/constants";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import './../DropdownList/index.scss';

const DocumentType = ({ options = [], _handleClick, label }) => {
	const [dropdownOpen, setDropdownOpen] = useState(false);

	options.forEach(function(item,i){
		if(item.type === Packets){
			options.splice(i, 1);
			options.unshift(item);
		}
	});

	const toggle = () => setDropdownOpen(prevState => !prevState);

	return (
		<Dropdown isOpen={dropdownOpen} toggle={toggle} className='file-upload-dropdown'>
			<label className='required d-block'>
				Document Type
			</label>
			<DropdownToggle caret className='d-flex'>
				<label>  {label}</label>
				<span className='ms-auto'>
					<FontAwesomeIcon icon={faAngleDown} />
				</span>
			</DropdownToggle>
			<DropdownMenu>
				{options.length !== 0 && options.map((item, index) => {
					return (
						<DropdownItem key={index} onClick={_handleClick} dropDownValue={item._id}>{item.type}</DropdownItem>
					);
				})}
			</DropdownMenu>
		</Dropdown>
	);
}

export default DocumentType;